<template>
    <div>
        <div class="outline_import" @click="outlineImportClick" v-loading.fullscreen.lock="loading">
            <span>导入大纲</span>
        </div>
        <input type="file" ref="fileInput" accept="text/plain" class="file-input" @change="handleFileChange">
    </div>
</template>
<script>
import chardet from 'chardet';
import iconvLite from 'iconv-lite';
export default {
    data() {
        return {
            maxFileSize: 6 * 1024 * 1024, // 6MB
            file: null,//选中的文件
            loading: false,
            updateTxtForm: [],
            allowedTypes: ['text/plain'], // 允许的MIME类型
        }
    },
    methods: {
        outlineImportClick() {
            this.$refs.fileInput.click()
        },
        async handleFileChange(e) {
            console.log(e.target.files)
            const files = e.target.files
            if (files.length === 0) return
            this.file = files[0]
            // 验证文件类型
            if (!this.allowedTypes.includes(this.file.type)) {
                this.file = null
                this.$refs.fileInput.value = ''
                this.$message.warning('必需是TXT文件类型')
                return
            }
            // 验证文件大小
            if (this.file.size > this.maxFileSize) {
                this.errorMessage = `文件大小超过${this.maxFileSize / 1024 / 1024}MB限制`
                this.$message.warning(`文件大小超过${this.maxFileSize / 1024 / 1024}MB限制`)
                this.file = null
                this.$refs.fileInput.value = ''
                return
            }
            this.updateSubmitClick()
            e.target.value = ''
        },
        //文件上传
        updateSubmitClick() {
            try {
                const file = this.file
                if (!file) {
                    this.$message.warning('请上传TXT文本')
                    return
                }
                this.loading = true
                const reader = new FileReader()
                reader.onload = (e) => {
                    const buffer = new Uint8Array(e.target.result);
                    // 1. 检测编码
                    const detectedEncoding = chardet.detect(buffer);
                    // console.log('detectedEncoding=',detectedEncoding);
                    // console.log('文件的编码格式=',detectedEncoding);
                    if (!iconvLite.encodingExists(detectedEncoding)) {
                        this.$message.error(`TXT文本不支持编码: ${detectedEncoding},请修改类型后重新上传`);
                        this.file = null
                        this.loading = false
                        return
                    }
                    const content = iconvLite.decode(buffer, detectedEncoding);
                    console.log('编码过后的文本=',content);
                    this.parseTxtToJson(content)

                }
                reader.onerror = (error) => {
                    this.$message.error('文件读取错误:', error)
                    setTimeout(() => {
                        this.loading = false
                    }, 1000);
                }
                reader.readAsArrayBuffer(file)
            } catch {
                setTimeout(() => {
                    this.loading = false
                }, 1000);
            }
        },
        // 解析内容
        parseTxtToJson(txtContent) {
            const lines = txtContent.split('\n').filter(line => line.trim() !== '');
            console.log(lines)
            if (lines.length === 0) {
                this.$message.error('内容为空');
                return;
            }
            // 存放作品名和章节
            const chapters = [];
            // 提取作品名
            // const workName = lines[0].trim();
            // if (workName.length > 150) {
            //     this.$message.error('作品名不能超过150字');
            //     return;
            // }

            let currentChapter = null;
            const chapterTitles = new Set(); // 用于检测重复标题

            for (let i = 0; i < lines.length; i++) {
                let line = this.clearZeroWidthText(lines[i].trim())
                if (line) {
                    line = this.removeHtmlTags(line)
                    //移除星号井号
                    line = line.replace(/\*+/g, '').replace(/#+/g, '')
                }
                // 检测是否是章节标题行（以"第X章"开头）
                if (line.match(this.titleContentFormat())) {
                    // 验证标题长度
                    if (line.length > 50) {
                        this.$message.error(`大纲标题"${line}"超过50字限制`);
                        this.loading = false
                        return;
                    }

                    // 检查是否重复
                    // if (chapterTitles.has(line)) {
                    //     this.$message.error(`发现重复章节标题: ${line}`);
                    //     return;
                    // }
                    // chapterTitles.add(line);

                    // 保存前一章（如果有）
                    if (currentChapter) {
                        // 验证内容长度
                        if (currentChapter.text.length > 500) {
                            this.$message.error(`大纲"${currentChapter.title}"内容超过500字限制`);
                            this.loading = false
                            return;
                        }
                        if (currentChapter.text.length === 0) {
                            // this.$message.error(`章节"${currentChapter.title}"内容不能为空`);
                            // return;
                            continue
                        }
                        // console.log('进行下一个不会在执行下来');
                        chapters.push(currentChapter);
                    }
                    // 开始新章节
                    currentChapter = {
                        chapter: chapters.length + 1, // 章节序号自动递增
                        title: line,
                        text: '',
                        content: ''
                    };
                    console.log('currentChapter=', currentChapter)
                } else if (currentChapter) {
                    // 添加内容到当前章节
                    if (currentChapter.content) {
                        currentChapter.content += '\n' + line;
                        currentChapter.text += '\n' + line;
                    } else {
                        currentChapter.content = currentChapter.title + '\n' + line;
                        currentChapter.text = line;
                    }

                } else {
                    console.log('标题格式有问题=')
                    this.$message.warning('小说内容格式不对')
                    this.loading = false
                    return
                }
            }
            console.log('到这里了')
            // 添加最后一章
            if (currentChapter) {
                if (currentChapter.content.length > 500) {
                    this.$message.error(`大纲"${currentChapter.title}"内容超过500字限制`);
                    this.loading = false
                    return;
                }
                chapters.push(currentChapter);
            }
            // this.updateTxtForm.title = workName
            this.updateTxtForm = chapters
            console.log('chapters=', chapters)
            let content = this.updateTxtForm.reduce((n, item) => {
                return n + '\n' + item.content
            }, '')
            console.log('content=', content)
            this.$emit('parseOutline', content)
            this.loading = false
        }
    }
}
</script>
<style lang="scss" scoped>
.outline_import {
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 17px;
    color: #FFFFFF;
    cursor: pointer;
}

.file-input {
    display: none;
}
</style>